








import { Component, Vue } from "vue-property-decorator";
import SettingMenuNavigation from "@/components/molecules/SettingMenuNavigation.vue";
import Notification from "@/components/molecules/Notification.vue";
import { NotificationState } from "@/store/modules/notification";

@Component({
  components: {
    SettingMenuNavigation,
    Notification,
  },
})
export default class SettingPageTemplate extends Vue {
  //---------------------------
  // computed
  //---------------------------
  get type(): string {
    return NotificationState.type;
  }
  get message(): string {
    return NotificationState.message;
  }
  get visibility(): boolean {
    return NotificationState.visibility;
  }
}
